// Where the signage app lives. Set for real deployments in .env.production; the
// fallback is the local dev server, so the preview works with no configuration.
export const SIGNAGE_URL = (import.meta.env.VITE_SIGNAGE_URL || 'http://localhost:3000').replace(/\/$/, '');

// The preview flag makes the signage app authenticate with this admin session
// instead of a device token, which is what lets it render without being paired.
// Used by both the embedded frame and the open-in-a-tab link.
export const PREVIEW_URL = `${SIGNAGE_URL}/?preview=1`;

// A display opened from this link authenticates with the token it carries,
// instead of being paired by code.
//
// A path rather than the query string the app itself reads, because this is
// the link a person sends to somebody: /s/<token> is served by the API through
// the signage distribution and answers with a page naming the account, so it
// unfurls in a message as "Claire's Litbyt" instead of as a hostname. It hands
// the browser straight on to /?code=<token>, which is still what the app reads
// and still works on its own - every link handed out before this one does.
export const shareURL = (token) => `${SIGNAGE_URL}/s/${encodeURIComponent(token)}`;

// An impersonation link points back at this admin site, which is why the API
// hands back a bare code and the URL is built here: the server never has to be
// told where its own front end is deployed.
export const impersonationURL = (code) =>
  `${window.location.origin}${window.location.pathname}?impersonate=${encodeURIComponent(code)}`;

// How long a name may be, matching models.AccountNameMaxLen on the server. It
// is duplicated because there is no shared vocabulary between Go and the
// browser here, and the server is the one that decides: this only stops a
// field accepting characters that would come back as a 400.
export const ACCOUNT_NAME_MAX = 40;
